@if (value) {
  <a [attr.href]="value" target="_blank" rel="noopener noreferrer"
    >Record <i-lucide name="external-link"></i-lucide
  ></a>
}
